fragment AlsoBoughtFragment on alsoBought_Entry {
  typeHandle
}
